import { api } from '@unicus/react-ui-kit';
import { message, Popconfirm, Tag } from 'antd';
import React from 'react';
import useAuth from 'core/hooks/useAuth';
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import usePermissions from 'core/hooks/usePermissions';
import googleCalendarIcon from '../assets/images/platforms/google-calendar.png';

const GoogleCalendarButton = () => {
  const { refresh, refreshToken, googleCalendarConnected } = useAuth();
  const { isProfessional } = usePermissions();
  const connected = googleCalendarConnected;
  const [disconnecting, setDisconnecting] = React.useState(false);

  function refreshProfessionalToken() {
    refresh({
      refreshToken,
      type: 'professional'
    });
  }

  function handleConnect(refreshToken) {
    api
      .post('users/connect-google-calendar', { refreshToken })
      .then((res) => {
        if (!(res && res.errors)) {
          message.success('Conectado com sucesso');
          refreshProfessionalToken();
        } else {
          message.error(
            'Ocorreu um erro inesperado ao processar sua solicitação'
          );
        }
      });
  }

  const connect = useGoogleLogin({
    onSuccess: (codeResponse) => {
      handleConnect(codeResponse.code);
    },
    flow: 'auth-code',
    ux_mode: 'popup',
    redirect_uri: 'postmessage',
    prompt: 'consent',
    scope: 'https://www.googleapis.com/auth/calendar'
  });

  function disconnect() {
    setDisconnecting(true);
    googleLogout();
    api
      .post('users/disconnect-google-calendar')
      .then((res) => {
        if (!(res && res.errors)) {
          message.success('Desconectado com sucesso');
          setDisconnecting(false);
          refreshProfessionalToken();
        } else {
          message.error(
            'Ocorreu um erro inesperado ao processar sua solicitação'
          );
        }
      })
      .catch(() => {
        setDisconnecting(false);
      });
  }

  async function toogleConnection() {
    if(!isProfessional) {
      message.warning('Você não tem permissão para acessar essa funcionalidade.');
      return;
    }

    if (connected) {
      setDisconnecting(true);
    } else {
      setDisconnecting(false);
      connect();
    }
  }

  const StatusTag = () => {
    if (connected) {
      return (
        <Popconfirm
          title="Deseja desconectar o Google Calendar?"
          open={disconnecting}
          onOpenChange={() => toogleConnection()}
          onConfirm={() => disconnect()}
          onCancel={() => setDisconnecting(false)}
          okText="Sim"
          cancelText="Não"
        >
          <Tag className="gx-pointer" color={connected ? "green" : undefined}>
            {connected ? 'Habilitado' : 'Desabilitado'}
          </Tag>
        </Popconfirm>
      );
    }

    return (
      <Tag className="gx-pointer" onClick={() => toogleConnection()}>
        {connected ? 'Habilitado' : 'Desabilitado'}
      </Tag>
    );
  };

  return (
    <div className="gx-platformlist-card">
      <div className="gx-platformlist-card-header">
        <div className="gx-platformlist-card-header-icon">
          <img alt="" src={googleCalendarIcon} />
        </div>
        <span className="gx-platformlist-card-header-name">
          Google Agenda
        </span>
      </div>
      <div className="gx-platformlist-card-content" />
      <div className="gx-platformlist-card-footer">
        <StatusTag />
      </div>
    </div>
  );
};

export default GoogleCalendarButton;














                                                                                                                             